import Divider from '@mui/material/Divider';
import type { GridProps } from '@mui/material/Grid';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';
import { StatusIndicator } from '../StatusIndicator/StatusIndicator.tsx';

const StyledWrapperDiv = styled('div')`
  width: 100%;
`;

const StyledStatusIndicator = styled(StatusIndicator)`
  display: block;
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;

type PageSectionProps = {
  children?: ReactNode;
  divider?: boolean;
  title: string;
  titleSize?: GridProps['size'];
  description?: string | ReactNode;
  dataTest?: string;
} & StatusProps;

type StatusProps =
  | {
      status?: undefined;
    }
  | {
      status: string;
      statusLabel?: string;
    };

export function PageSection(props: PageSectionProps): ReactElement {
  const { children, divider, title, status, description, titleSize = 3, dataTest } = props;

  return (
    <StyledWrapperDiv data-test={dataTest || title.toLowerCase().replace(/\s/g, '-')}>
      <Grid container sx={{ padding: theme => theme.spacing(4) }}>
        <Grid size={titleSize || 3}>
          <Typography
            data-test="title"
            sx={{
              ':before': {
                borderTopColor: 'primary.main',
                borderTopStyle: 'solid',
                borderTopWidth: '1px ',
                content: '""',
                display: 'block',
                marginBottom: '8px',
                width: '12px',
              },
            }}
            variant="h2"
          >
            {title}
          </Typography>

          {status && <StyledStatusIndicator status={status} label={props.statusLabel} data-test="status" />}

          {description}
        </Grid>
        {children}
      </Grid>
      {divider && <Divider />}
    </StyledWrapperDiv>
  );
}
